
import { mapActions, mapState } from "vuex";
import { subscribeUser } from "~/common/services/newsletter.service";

export default {
	data() {
		return {
			localLoading: false,
		};
	},
	computed: {
		...mapState("account", ["isLoggedIn", "user", "logInPopupBlocked"]),
		...mapState("newsletter-banner", ["isSubscribing"]),
	},
	methods: {
		...mapActions("account", [
			"OPEN_FIREBASE_POPUP",
			"OBSERVE_USER_LOGIN_CHANGES",
		]),
		async onSignUp() {
			if (this.isLoggedIn) {
				await this.doSubscribe();
				return;
			}

			await this.OPEN_FIREBASE_POPUP();
			if (this.logInPopupBlocked) {
				// if the popup is blocked, abort and let the user try again
				this.localLoading = false;
				this.$store.commit(
					"account/UPDATE_LOG_IN_POPUP_BLOCKED",
					false
				);
				return;
			}
			this.localLoading = true;
			await this.OBSERVE_USER_LOGIN_CHANGES(this.doSubscribe);
		},
		async doSubscribe() {
			this.$store.commit("newsletter-banner/USER_SUBSCRIBING");
			await subscribeUser(this.$axios, this.$config, {
				email: this.user.data.email,
			});
			this.$store.commit("newsletter-banner/USER_SUBSCRIBED");
		},
	},
};
